// Shared loading for the booking detail pages (hotel, package, adventure, cruise).
import { bookingDetails, headers } from '../links'
import { formatDate, formatMoney, formatWeekday } from '../utils/format'

// What the shared payment panel needs, from an API that has no `overview` yet.
export function paymentFallback (booking) {
  const record = booking.booking_payment || {}
  const paid = /confirm|paid/i.test(booking.status || '')
  return {
    paid,
    transaction_id: record.transaction_id || booking.transaction_id || null,
    authorization_code: record.authorization_code || booking.authorization_code || null,
    card_holder: record.card_holder_name || null,
    card_number: record.card_number || null,
    result: record.payment_status_message || null,
    paid_at: record.created_at || null,
    attempts: []
  }
}

export default {
  data () {
    return {
      booking: null,
      loading: true
    }
  },
  computed: {
    // false while the API in use doesn't return the new blocks yet (not deployed)
    hasOverview () {
      return !!(this.booking && this.booking.overview)
    },
    customer () {
      return this.hasOverview ? this.booking.overview.customer : null
    },
    payment () {
      return this.hasOverview ? this.booking.overview.payment : paymentFallback(this.booking)
    },
    travellers () {
      return (this.booking && this.booking.booking_traveler) || []
    },
    contact () {
      return this.booking ? this.booking.booking_data : null
    },
    guestsLabel () {
      const adults = Number(this.booking.adults) || 0
      const children = Number(this.booking.children) || 0
      const parts = [`${adults} adult${adults === 1 ? '' : 's'}`]
      if (children) parts.push(`${children} child${children === 1 ? '' : 'ren'}`)
      return parts.join(', ')
    }
  },
  methods: {
    money (value, currency) {
      return formatMoney(value, currency || 'USD')
    },
    date (value) {
      return formatDate(value)
    },
    dateTime (value) {
      return formatDate(value, true)
    },
    weekday (value) {
      return formatWeekday(value)
    },
    notify (color, text) {
      this.$root.$emit('tn-notify', { color, text })
    },
    // silent: refresh the data in place (no skeleton), e.g. after an action on the page
    loadBooking (silent = false) {
      if (!silent) this.loading = true
      this.$http.get(bookingDetails(this.$route.params.id), { headers: headers(this.$cookies.get('userToken')) }).then(res => {
        this.booking = res.body.bookingDetails || null
      }).catch(() => {
        // a failed silent refresh keeps what is on screen
        if (!silent) this.booking = null
      }).finally(() => {
        this.loading = false
      })
    }
  },
  created () {
    this.loadBooking()
  }
}
